export enum ResourceEndpointVersion {
  DEFAULT = 'v2',
  LEGACY = '',
}

export interface ResoResourceConfig {
  name: string;
  endpoint: string;
  version?: ResourceEndpointVersion;
}

// Resource type definitions
export enum ResoResource {
  SCHOOL = 'School',
  CITY_ZIP_CODE = 'CityZipCode',
  BUILDING_NAME = 'BuildingName',
  SUBDIVISION = 'Subdivision',
  SCHOOL_DISTRICT = 'SchoolDistrict',
  AREA = 'PropertyArea',
}

// Field definitions for each resource type
export enum SchoolField {
  NAME = 'SchoolName',
  TYPE = 'SchoolType',
  COUNTY = 'SchoolCounty',
  KEY = 'SchoolKey',
  DISTRICT_NAME = 'SchoolDistrictName',
  DISTRICT_KEY = 'SchoolDistrictKey',
  MODIFICATION_TIMESTAMP = 'SchoolModificationTimestamp',
}

export enum AreaField {
  KEY = 'PropAreaKey',
  COUNTY = 'PropAreaCounty',
  TYPE = 'PropAreaType',
  STATE = 'PropAreaState',
  MODIFICATION_TIMESTAMP = 'PropAreaModificationTimestamp',
}

export enum CityZipCodeField {
  KEY = 'CityZipCodeKey',
  CITY = 'CityZipCodeCity',
  CITY_NAME = 'CityZipCodeCityName',
  COUNTY = 'CityZipCodeCounty',
  STATE = 'CityZipCodeState',
  ZIP = 'CityZipCodeZip',
  PREFERRED_CITY = 'CityZipCodePreferredCity',
  MODIFICATION_TIMESTAMP = 'CityZipModificationTimestamp',
}

export enum BuildingNameField {
  KEY = 'BldgNameKey',
  NAME = 'BldgNameName',
  RELATED_KEY = 'BldgNameRelatedBldgNameKey',
  STATUS = 'BldgNameStatus',
  URL = 'BldgNameURL',
  COUNTY = 'BldgNameCounty',
  STATE = 'BldgNameState',
  MODIFICATION_TIMESTAMP = 'BldgNameModificationTimestamp',
}

export enum SubdivisionField {
  KEY = 'LoSubdivisionKey',
  NAME = 'LoSubdivisionName',
  SYSTEM_VALIDATED = 'LoSubdivisionSystemValidatedFlag',
  COUNTY = 'LoSubdivisionCounty',
  STATE = 'LoSubdivisionState',
  MODIFICATION_TIMESTAMP = 'LoSubdivisionModificationTimestamp',
  STATUS = 'LoSubdivisionStatus',
  URL = 'LoSubdivisionURL',
  RELATED_KEY = 'LoSubdivisionRelatedSubdivisionKey',
}

export enum SchoolDistrictField {
  KEY = 'SchoolDistrictKey',
  NAME = 'SchoolDistrictName',
  URL = 'SchoolDistrictURL',
  COUNTY = 'SchoolDistrictCounty',
  STATE = 'SchoolDistrictState',
  MODIFICATION_TIMESTAMP = 'SchoolDistrictModificationTimestamp',
}

// Type mapping to ensure type safety when using fields
export type ResourceFields = {
  [ResoResource.SCHOOL]: SchoolField;
  [ResoResource.CITY_ZIP_CODE]: CityZipCodeField;
  [ResoResource.BUILDING_NAME]: BuildingNameField;
  [ResoResource.SUBDIVISION]: SubdivisionField;
  [ResoResource.SCHOOL_DISTRICT]: SchoolDistrictField;
  [ResoResource.AREA]: AreaField;
};

export const RESO_RESOURCES: Record<ResoResource, ResoResourceConfig> = {
  [ResoResource.AREA]: {
    name: 'PropertyArea',
    endpoint: 'PropertyArea',
    version: ResourceEndpointVersion.LEGACY,
  },
  [ResoResource.SCHOOL]: {
    name: 'School',
    endpoint: 'School',
    version: ResourceEndpointVersion.LEGACY,
  },
  [ResoResource.BUILDING_NAME]: {
    name: 'BuildingName',
    endpoint: 'BuildingName',
    version: ResourceEndpointVersion.LEGACY,
  },
  [ResoResource.CITY_ZIP_CODE]: {
    name: 'CityZipCode',
    endpoint: 'CityZipCode',
    version: ResourceEndpointVersion.LEGACY,
  },
  [ResoResource.SUBDIVISION]: {
    name: 'Subdivision',
    endpoint: 'Subdivision',
    version: ResourceEndpointVersion.LEGACY,
  },
  [ResoResource.SCHOOL_DISTRICT]: {
    name: 'SchoolDistrict',
    endpoint: 'SchoolDistrict',
    version: ResourceEndpointVersion.LEGACY,
  },
} as any;
